module.exports = __webpack_public_path__ + "media/images/cross-47a7faa7.png";